const ReceiptTypeEnum = {
  CASH: 1,
  BANK_TRANSFER: 2,
  WALLET: 3,
  CARD: 4,
  OTHER: 5
}
// Reference to PaymentTypeEnum
export default ReceiptTypeEnum


// WEBPACK FOOTER //
// ./src/enum/receiptTypeEnum.js